import React from "react";

import moment from "moment";

import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import { getValidations } from "../../../helpers/validations/getValidations";
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";

export const ValidatedDate = (props) => {
  const { validations = [], value, ...otherProps } = props;
  const { validators, errorMessages } = validations ? getValidations(validations) : [];

  return (
    <ValidatedDatePicker
      {...otherProps}
      format="dd/MM/yyyy"
      okLabel="Aceptar"
      clearLabel="Limpiar"
      cancelLabel="Cancelar"
      value={moment(value).isValid() ? moment(value) : null}
      fullWidth
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
      validators={[...validators, "isValidDate"]}
      errorMessages={[...errorMessages, "Fecha inválida"]}
    />
  );
}

export const DatePickerGeneric = (props) => {
  const { value, onChange, ...otherProps } = props;
  return (
    <KeyboardDatePicker
      {...otherProps}
      format="dd/MM/yyyy"
      okLabel="Aceptar"
      clearLabel="Limpiar"
      cancelLabel="Cancelar"
      value={moment(value).isValid() ? moment(value) : null}
      onChange={onChange}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
    />
  );
}

export const GHourPicker = ({...props}) => {
  const { validations = [], value, ...otherProps } = props;
  const { validators, errorMessages } = validations ? getValidations(validations) : [];

  return (
    <KeyboardTimePicker
      {...otherProps}
      id="time-picker"
      value={value}
      fullWidth
      KeyboardButtonProps={{
        'aria-label': 'change time',
      }}
      validators={[...validators, "isValidDate"]}
      errorMessages={[...errorMessages, "Fecha inválida"]}
    />
  )
}